import { getCurrentUserToken } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import {
  getInvoiceHistory,
  InvoiceHistoryFilters,
} from "../../handlers/getInvoiceHistory";

export const INVOICE_HISTORY_QUERY_KEY = "invoice-history";

interface UseInvoiceHistoryQueryOptions {
  filters?: InvoiceHistoryFilters;
  enabled?: boolean;
}

export const useInvoiceHistoryQuery = ({
  filters,
  enabled = true,
}: UseInvoiceHistoryQueryOptions = {}) => {
  return useQuery({
    queryKey: [INVOICE_HISTORY_QUERY_KEY, filters],
    queryFn: async () => {
      const token = await getCurrentUserToken();
      if (!token) {
        throw new Error("No authentication token");
      }

      const response = await getInvoiceHistory({ token, filters });
      return response.data?.invoices ?? [];
    },
    enabled,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
